<template>
  <div id="frstSreenFormStart" class="rapeAlign">
    <div id="frstSreenFormStartWrap">
      <div>
        <div class="rangeWrap" >
          <rangeTopLine></rangeTopLine>
          <fmRange></fmRange>
          <rangeBottomLine></rangeBottomLine>
        </div>
        <div class="rangeWrap">
          <fmRangePdl></fmRangePdl>
        </div>
        <div class="rangeWrap">
          <fmRangePdlPercent></fmRangePdlPercent>
        </div>
      </div>
      <div id="dealResult">
        <div class='payBlock'>
          <div class = 'paytxt'>
          <p>Платеж:</p>
          <p class='resultxt'>{{FixedPay | moneyFormat}}<span class="rubl">a</span></p>
          </div>
          <div class = 'paytxt'>
          <p>Дата платежа:</p>
          <p>{{paymentInfo.paymentDate}}</p>
          </div>
        </div>
        <div class = 'maxBlock'>
           <p v-show="!pdl.active">Максимально выгодный продукт</p>
           <p v-show="pdl.active">Переплата: {{pdl.Overpayment | moneyFormat}}<span class="rubl">a</span></p>
           <p v-show="pdl.active">Платеж: {{pdl.Payment | moneyFormat}}<span class="rubl">a</span></p>
        </div>
        <div class='payBlock'>
        <button class="svgMoney" v-on:click.prevent="scrTo">
          <IconBase :viewBox="'0 0 24 24'">
            <IconPayments ></IconPayments>
          </IconBase>
          <span>Получить деньги</span>
          <IconBase :viewBox="'0 0 24 24'">
            <IconPayments ></IconPayments>
          </IconBase>
        </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState,mapGetters} from 'vuex';
  export default {
    name: "frstScreenFormStart",
    data(){
      return {

      }
    },
    components: {
      fmRangePdl: () => import('@/components/chunk/rangepdl'),
      fmRangePdlPercent: () => import('@/components/chunk/fmRangePdlPercent'),
      fmRange: () => import('@/components/chunk/range'),
      IconBase: () => import('@/components/svg/IconBase'),
      IconPayments: () => import('@/components/svg/payments-finance-36'),
      rangeTopLine: () => import('@/components/chunk/rangeTopLine'),
      rangeBottomLine: () => import('@/components/chunk/rangeBottomLine'),
    },
    computed: {
      ...mapState({
        minBaseProduct:state=>state.Deal.minBaseProduct,
        SelectedSumm:state=>state.Deal.SelectedSumm,
      }),
      ...mapGetters([
        'FixedPay',
        'paymentInfo'
      ]),
      pdl(){
       if (this.SelectedSumm < this.minBaseProduct.Amount) {
         return {
           active:true,
           Overpayment:this.SelectedSumm*0.3,
           Payment:this.SelectedSumm + this.SelectedSumm*0.3
         }
       } else {
         return {
           active:false,
           Overpayment:0,
           Payment:0
         }
       }
      }
    },
    methods:{
      scrTo(){
        this.$parent.$parent.$children.forEach(item => {
          if (item.$refs.formAlign != undefined) {
            window.scrollTo({
              left:0,
              top:item.$refs.formAlign.offsetTop,
              behavior: 'smooth'
            });
          }
        });
      }
    }

  }
</script>

<style scoped>
  #frstSreenFormStart {background: #0D5A44;}
  h2 {font-size: 5.9vw;text-align: center;padding: 3vw 0;}
  .title {display: flex;justify-content: space-between;align-items: center}
  .title {font-size: 3.2vw;}
  .title:first-child {font-size: 4.3vw}
  #frstScreenDesc {font-size: 3.6vw; text-align: center; padding: 5vw 0vw 2vw;}
  #dealResult {border-top: 1px solid #0A4D3A; padding: 2vw 0 10vw;text-align: center}
  /* #dealResult p:first-child {font-size: 4.3vw;}
  #dealResult p:nth-child(2) {font-size: 9.6vw;font-weight: bold;padding: 3vw 0;} */
  #dealResult button {}
  .maxBlock{background-color: white; color: #0A4D3A;    flex-direction: column;}
  .paytxt{display: flex;align-items: center;justify-content: space-between;}
  .maxBlock{margin: 14px 0;height: 75px;display: flex; align-items: center; justify-content: center;}
  .maxBlock > p{font-weight: bold;}

  .rangeWrap{margin: 5vw 0;}
  @media screen and (min-width: 760px) {
    .rangeWrap{margin:0;}
    #frstSreenFormStart {width:73vw;height: 20.9vw}
    #frstSreenFormStartWrap {display: flex;height: 100%;}
    #frstSreenFormStartWrap > div{display: flex;flex-direction: column;justify-content: space-around}
    #frstSreenFormStartWrap > div:first-child{width: 42.2vw;padding: 0 3.1vw;}
    #frstSreenFormStartWrap > div:last-child{height: calc(100% - 3.2vw);width: calc(100% - 43vw);padding: 1.6vw 0}
    h2 {font-size: 2vw;padding:0;text-align: left}
    .title {}
    .title {font-size: 1.1vw}
    .title:first-child {font-size: 1.4vw;}
    #frstScreenDesc {font-size: 14px;padding:  0;text-align: left}
    #dealResult {padding: 0;border-top:0;border-left:1px solid #0A4D3A}
    /* #dealResult p:first-child {font-size: 1.4vw;}
    #dealResult p:nth-child(2) {font-size: 3.2vw;padding:0;} */
    #dealResult button {width: 23.7vw;}

  }
  @media screen and (min-width: 1140px) {
    #frstSreenFormStart {width:832px;height: 275px;}
    #frstSreenFormStartWrap > div:first-child{width: 630px;padding: 0 35px;}
    #frstSreenFormStartWrap > div:last-child{height: calc(100% - 0px);width: calc(100% - 470px);padding: 0px 0}
    h2 {font-size: 22px;}
    .title {}
    .title {font-size: 12px;}
    .title:first-child {font-size: 16px}
    #frstScreenDesc {font-size: 14px}
    #dealResult {}
    /* #dealResult p:first-child {font-size: 16px;} */
    /* #dealResult p:nth-child(2) {font-size:36px;} */
    #dealResult button {width: 220px;}

    .resultxt{font-size:36px;}
    .maxBlock > p{font-size: 20px;}
    .maxBlock{height: 75px; margin:0;}
    .payBlock{padding: 17px 9px;}
  }
</style>
